import { TbShirtSport } from "react-icons/tb";
import { HiOutlineTicket } from "react-icons/hi";
import { MdOutlineEventSeat, MdOutlinedFlag } from "react-icons/md";
import Link from "@mui/material/Link";

export const purchaseSeatsLanguages = {
  similarSeatModalBody: (seatTitle: string) => (
    <>
      We are going to apply the same or similar seats to all games in your pack.
      Seat locations will be visible on the checkout page.
    </>
  ),
  progressBarText:
    "Add 2 games and get 10% off, add 4 games and get 20% off, or add 6+ games for 30% off & an exclusive Midland Rockhounds Crossbody Bag!",
  progressBarAditionalText: "to continue and receive 10% off.",
};

export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "Choose Your Games",
    description: "Select the games you wish to attend.",
  },
  {
    icon: <MdOutlineEventSeat />,
    title: "Login to MiLB.com",
    description:
      "Click Continue and connect your Midland RockHounds account using our secure MLB.com login.",
  },
  {
    icon: <TbShirtSport />,
    title: "Select Your Seats",
    description: "Select the seats you wish to purchase for each game.",
  },
  {
    icon: <HiOutlineTicket />,
    title: "Get Your Tickets",
    description: (
      <>
        Tickets will be available in your{" "}
        <Link
          href={
            "https://mlb.tickets.com/?agency=MRHM_MYTIXX&orgid=56878#/auth/login"
          }
          target={"_blank"}
          sx={{
            fontWeight: 500,
            color: "primary.main",
            textDecoration: "none",
          }}
        >
          MyProVenue
        </Link>{" "}
        within 24 hours of purchase. Reach out to Live Fan Support for any
        questions.
      </>
    ),
  },
];

export const faqs = [
  {
    title: "How does the Rockhounds Build Your Own Flex Program work?",
    description:
      "The Rockhounds Build Your Own Flex Program allows fans to select any seat to select games hosted by the Rockhounds. The more games you purchase the more you save! Simply log into your MLB.com and select games.",
  },
  {
    title: "Do I have to select all my games now?",
    description: "Yes, you must select all games at the time of purchase.",
  },
  {
    title: "Can I choose seats throughout the venue?",
    description: "Yes, you can choose from all currently available inventory.",
  },
  {
    title: "Where are event tickets delivered?",
    description: (
      <>
        Tickets are delivered directly within your Midland Rockhounds{" "}
        <Link
          href={
            "https://mlb.tickets.com/?agency=MRHM_MYTIXX&orgid=56878#/auth/login"
          }
          target={"_blank"}
          sx={{
            fontWeight: 500,
            color: "primary.main",
            textDecoration: "none",
          }}
        >
          MyProVenue
        </Link>{" "}
        Account.
      </>
    ),
  },
  {
    title: "Where can I receive my Midland Rockhounds Crossbody Bag?",
    description:
      "The Rockhounds Box Office will be in touch with all fans who qualify for the Midland Rockhounds Crossbody bag.",
  },
];
